import classNames from "classnames";
import { ReactNode } from "react";
import { EXPOSED, MONITORING } from "constants/nexusTrackerStatus";
import { FILED, IN_CART, PROCESSING } from "constants/filing";
import {
  IN_REVIEW,
  NOT_STARTED,
  PENDING_DETAILS,
  REGISTERED,
  VALIDATING,
} from "constants/salesTaxRegistrationStatusType";

export const Status = ({
  children,
  status,
}: {
  children: ReactNode;
  status: string;
}) => {
  return (
    <div
      className={classNames(
        "t-max-w-fit t-text-body-sm t-text-center t-px-3 t-py-1 t-text-nowrap t-rounded-2xl",
        {
          "!t-bg-neutral-0 !t-text-neutral-70": status === MONITORING,
        },
        {
          "t-bg-blue-10 t-text-blue-70":
            status === IN_CART ||
            status === PROCESSING ||
            status === IN_REVIEW ||
            status === VALIDATING,
        },
        {
          "t-bg-green-10 t-text-dark_green-70":
            status === FILED || status === REGISTERED,
        },
        {
          "t-bg-red-10 t-text-red":
            status === EXPOSED ||
            status === NOT_STARTED ||
            status === PENDING_DETAILS,
        }
      )}
    >
      <span className="t-capitalize">{children}</span>
    </div>
  );
};
